/* eslint-disable prettier/prettier */
import moment from "moment";
import _ from "lodash";

//import { TokenService } from "../services/storage.service";

const UtilService = {
  
  init() {
    console.log('Init Util');
  },

  getCycleLbl(cycle) {
    switch(cycle) {
      case 0:
         return 'Start';
         
      case 1:
         return '1 day';
          
      case 2:
         
         return '1 week';
      case 3:
         
        return '1 month'; 
      case 4:
         
         return '3 months';
      case 5:
         return '6 months';
      case 6:
         return '1 year';
    }

  },

  extendMemries(listmemries,tags) {
    console.log("Extending Memries. Memry Count", listmemries.length,"Tag Count", tags.length);
     var overduecount = 0;
     var todaycount = 0;
    
     var memries = [];
     var drafts = [];
     
     var today = moment().startOf('day');

    _.each(listmemries, (memry) => {
       
      memry.lastscoredlbl = 'never';
      if(memry.lastscored) {
        var momScored = moment(memry.lastscored);   
        if(momScored.isValid())
          memry.lastscoredlbl =   momScored.toNow(true) + " ago";
      }

      memry.lastreviewedlbl = 'never';
      if(memry.lastreviewed) {
        var momReviewed = moment(memry.lastreviewed);
        if(momReviewed.isValid()) {
          if(today.format('YYYYMMDD') != momReviewed.format('YYYYMMDD'))
            memry.lastreviewedlbl =   momReviewed.to(today,true) + " ago";
          else
            memry.lastreviewedlbl = 'Today';

        }
      }

      var created = moment(memry.datecreated);
      //memry.datecreated = created.toDate();

      var prelbl = '';
      var postlbl = ' ago';
      if(created > moment()) {
          postlbl = '';
          prelbl = 'in ';
      }
      
      memry.cyclelbl = this.getCycleLbl(memry.cycle);

      memry.datecreatedlbl = prelbl + created.to(today,true) + postlbl;
      
      memry.overdue = !moment().isSame(moment(memry.duedate), "day"); 

      if(memry.active == 1) {
        if(memry.overdue) {
        
          overduecount++;

          prelbl = '';
           postlbl = ' ago';
          var duedate = moment(memry.duedate);
          if(duedate > moment()) {
              postlbl = '';
              prelbl = 'in ';
          }
          memry.duedatelbl = prelbl + duedate.to(today,true)  + postlbl;
        }
        else {
          todaycount++;
          memry.duedatelbl = "Today";
        
        }
      }
      
        if(memry.tags) {
          memry.tags = JSON.parse(memry.tags);
          if(Array.isArray(memry.tags) &&  memry.tags.length > 0) {
            memry.tagpaths = [];
            _.each(memry.tags, (tag) => {
                let findtag = _.find(tags,{'id':tag});
                if(findtag)
                  memry.tagpaths.push(findtag.path);
            });
          }
        }

        if(memry.active == 1)
          memries.push(memry);
        else
          drafts.push(memry);
        
    });
    return { memries: memries, drafts: drafts, overduecount: overduecount, todaycount: todaycount};
  },

  
};

export default UtilService;